var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentCompletedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 191,
    viewBox: "0 0 191 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 191,
    height: 191,
    rx: 95.5,
    fill: "#1DAB87"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.236 56.0958C160.795 60.3196 160.255 66.6282 156.031 70.1866L77.7815 136.109C73.624 139.612 67.43 139.151 63.8359 135.073L33.9089 101.111C30.2575 96.9679 30.6565 90.6488 34.8001 86.9975C38.9437 83.3461 45.2628 83.7451 48.9141 87.8887L72.3751 114.512L143.146 54.891C147.369 51.3327 153.678 51.8721 157.236 56.0958Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCompletedIcon);
export default __webpack_public_path__ + "static/media/payment-completed-icon.40e866f58e34a38cd90f5fdcba0a2da8.svg";
export { ForwardRef as ReactComponent };